<template>
    <DFormRow
        :label="__('customers.contracts.phase_text')"
        :error="errors.phase_text"
    >
        <DInput
            :id="`phase_text${idSuffix}`"
            :model-value="modelValue"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: [String, Number],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    idSuffix: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['update:modelValue'])
</script>
